import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { apiFetch } from '../../api/client';
import { JobDetail } from '../../models/JobDetail';
import JobDetailComponent from './JobDetailComponent';

const Job = (): React.JSX.Element => {
   const location = useLocation();
   const [jobDetail, setJobDetail] = useState<JobDetail>();

   const fetchJobDetail = (): void => {
      apiFetch<JobDetail>('/api' + location.pathname, { credentials: 'include' })
         .then((data) => {
            setJobDetail(data);
         })
         .catch((error) => {
            console.error(error);
            setJobDetail(undefined);
         });
   };

   useEffect(() => {
      fetchJobDetail();
   }, [location.pathname]);

   const isRunning = jobDetail?.status === 'running';

   useEffect(() => {
      if (!isRunning) {
         return;
      }

      const intervalId = setInterval(() => {
         fetchJobDetail();
      }, 5000);

      return () => clearInterval(intervalId);
   }, [isRunning, location.pathname]);

   return (
      <article className="md-content__inner md-typeset">{jobDetail && <JobDetailComponent {...jobDetail} />}</article>
   );
};

export default Job;
